module.exports = __webpack_public_path__ + "img/PyramidProgressives_EGM.6b0dcc90.png";